module.exports = __webpack_public_path__ + "media/customizations/cai/logo-6a5dfe975426b8e246d4d2db32afa9fe.png";